import { render, staticRenderFns } from "./imageDetailsComponent.vue?vue&type=template&id=27935525&scoped=true"
import script from "./imageDetailsComponent.vue?vue&type=script&lang=js"
export * from "./imageDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./imageDetailsComponent.vue?vue&type=style&index=0&id=27935525&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27935525",
  null
  
)

export default component.exports